import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A whole new level of technical decision",
  "description": "",
  "published": "2019-07-08T00:00:00.000Z",
  "redirect_from": ["/blog/a-whole-new-level-of-technical-decision/swizec/9149"],
  "categories": "Technical",
  "hero": "./img/techletter.app-screenshot-1562603962613.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know how hard it can be to choose React vs. Vue, Redux vs. useReducer, styled-components vs. css modules ... child's play compared to the technical decision I helped with last week. Wow 😳`}</p>
    <p>{`A few weeks ago I wrote `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/build-one-to-throw-away/swizec/9131"
      }}>{`Build one to throw away`}</a>{` about replacing an in-house marketing automation system with a 3rd party solution. My baby for over 2 years is going bye bye. Thank god.`}</p>
    <p>{`I'm ready to have new babies, work on other interesting problems, y'know ...`}</p>
    <p>{`Well, time has come to pick a replacement. And ho boy is that a whole new level of technical decision making. Never thought it could be so difficult 🤯`}</p>
    <p>{`You google "marketing automation", click top result, swipe the company card, and voila. Right?`}</p>
    <p>{`Nope.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1146485404373094400"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "70.4035874439462%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'281\\'%20viewBox=\\'0%200%20400%20281\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%209c-4%202-7%207-7%2011%200%205%201%209%203%209v1c0%202%205%206%2010%207%203%200%205%200%208-2%206-2%206-4%202-4-3%200-4-3-1-5%201-1%203-2%204-1l1-1%202-1c3%200%200-10-6-13-5-4-11-4-16-1m222%2066v6h3c4%200%208-4%208-8-1-3-4-5-8-5h-3v7M108%20222l-1%201c-1-1-1%200-1%201l-1%203c-2%202-1%207%202%208%207%203%2013-7%207-12-2-2-6-3-6-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/94b661cf1d1a23053697b904884128f4/ca0a1/techletter.app-screenshot-1562603962613.webp 223w", "/static/94b661cf1d1a23053697b904884128f4/75680/techletter.app-screenshot-1562603962613.webp 445w", "/static/94b661cf1d1a23053697b904884128f4/0ba47/techletter.app-screenshot-1562603962613.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/94b661cf1d1a23053697b904884128f4/e92b6/techletter.app-screenshot-1562603962613.png 223w", "/static/94b661cf1d1a23053697b904884128f4/e66bf/techletter.app-screenshot-1562603962613.png 445w", "/static/94b661cf1d1a23053697b904884128f4/6af66/techletter.app-screenshot-1562603962613.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/94b661cf1d1a23053697b904884128f4/6af66/techletter.app-screenshot-1562603962613.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Here's what choosing a vendor to replace your hard work actually looks like:`}</p>
    <h2 {...{
      "id": "1--what-do-you-want-and-whats-out-there"
    }}>{`1 👉 What do you want and what's out there?`}</h2>
    <ol>
      <li parentName="ol">{`You get a long list of requirements from Product – some must-haves, some nice-to-haves, some implied assumeds`}</li>
      <li parentName="ol">{`You add requirements from the old implementation that you remember are important`}</li>
      <li parentName="ol">{`After some back-and-forth, a few conversations with stakeholders, you know what you're looking for`}</li>
      <li parentName="ol">{`You Google "marketing automation" and drown in marketing speak. Everything is perfect, everything solves all your problems, everything does everything`}</li>
    </ol>
    <p>{`At this point you're like`}</p>
    <p><img parentName="p" {...{
        "src": "/94b28edce5d9cb8a7ddf5274b8353dde/media-8whUqn4Zgfg8Krz36O-giphy.gif",
        "alt": "confused_sweating giphy"
      }}></img></p>
    <p>{`The marketing automation space has `}<em parentName="p">{`exploded`}</em>{` in the last couple of years. Everything from complex email campaigns to chatbots and integrated email-website-facebookads.`}</p>
    <p>{`There's a lot to dig through.`}</p>
    <h2 {...{
      "id": "2--what-even-looks-like-a-maybe"
    }}>{`2 👉 What even looks like a maybe?`}</h2>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`You ask around for recommendations, opinions, and experiences. Learning from other people's mistakes is always a great approach.`}</li>
      <li parentName="ol">{`You create a list of potential vendors. Everyone who does "marketing automation"`}</li>
      <li parentName="ol">{`You go through all the websites and create a ranked list`}</li>
    </ol>
    <p>{`I ranked in my mind, but I should've created a spreadsheet. The formula went something like this`}</p>
    <p>{`If the page looks scammy – super marketing speak, plenty of conversion optimizers, bunch of growth hacks – disqualify.`}</p>
    <p>{`If the page looks professional, clean, like real care was put into it 👉 plus point.`}</p>
    <p>{`If the tool was recommended by a friend 👉 2 plus points.`}</p>
    <p>{`If a friend says they've struggled with the tool 👉 3 minus points.`}</p>
    <p>{`If I've heard of the tool or company before 👉 plus point.`}</p>
    <p>{`You have a list of potential vendors. Companies you'd trust with your data, expect to stick around for a few years, think are serious about marketing automation being their thing that they do.`}</p>
    <p>{`Starting to look like a solvable problem`}</p>
    <p><img parentName="p" {...{
        "src": "/e7bd803688f5cc3a7037a36ae03b0f4d/media-3o7qDG6DXSQYRRMNgI-giphy.gif",
        "alt": "breathing_easier giphy"
      }}></img></p>
    <h2 {...{
      "id": "3--what-does-everything-you-need"
    }}>{`3 👉 What does everything you need?`}</h2>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`You have a narrow selection of maybes`}</li>
      <li parentName="ol">{`You go through their list of features`}</li>
      <li parentName="ol">{`Plus 1 point for every feature from your list`}</li>
    </ol>
    <p>{`Comparing marketing pages can be difficult. Different companies use different words to describe the same things, they all promise everything and they all mean slightly different behaviors.`}</p>
    <p>{`All of them say "We have A/B testing", for example. But what does that mean?`}</p>
    <p>{`Well in most cases it means "You can test subject lines"`}</p>
    <p>{`Yeah what about the copy itself? What about the customer segment? How about the medium of outreach?`}</p>
    <p>{`You gotta be careful 😉`}</p>
    <p>{`The best way I've found to compare SaaS companies is their pricing page. That's where they list every feature in a list because they want to show which feature comes with which package.`}</p>
    <p>{`If they just did that on their homepage instead of using marketing speak life would be so much easier.`}</p>
    <p>{`You now have a ranked list of companies. At the top are the most serious companies that cover the most of your features.`}</p>
    <p><img parentName="p" {...{
        "src": "/281b9eeb9989cefe2497659d5d692e72/media-GVH7ZnzMGFEjK-giphy.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "4--what-does-it-feel-like"
    }}>{`4 👉 What does it feel like?`}</h2>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Pick 3 companies from top of your list`}</li>
      <li parentName="ol">{`All 3 likely cover all your must-haves and need-to-haves`}</li>
      <li parentName="ol">{`Try them out`}</li>
    </ol>
    <p>{`At this point you're making a technical assessment: Which of the companies that does everything we need, does it best?`}</p>
    <p>{`You're looking to sign up as a user, click around the interface, try the features on your list.`}</p>
    <p>{`What's it like to build an automation? Could a non-technical person use it? Does it feel sluggish and clunky? Can you do all the weird things you want to do? What does the editor feel like? Does everything fit together nicely?`}</p>
    <p>{`Are there any red flags their marketing speak didn't highlight? Features they mention that aren't there yet?`}</p>
    <p>{`If you were to integrate this with your system, could you? How hard would that be? How well would it work? What's their API like?`}</p>
    <p>{`Bonus points, if you reach out to their support to see how hard it would be to get help when something goes wrong. Because something `}<em parentName="p">{`will`}</em>{` go wrong.`}</p>
    <p>{`Discard what doesn't pass muster`}</p>
    <p><img parentName="p" {...{
        "src": "/5a4cc6ca4e9109bd312a80e436e48708/media-oS8pRFxbD0d44-giphy.gif",
        "alt": "starting_to_get_a_grip giphy"
      }}></img></p>
    <h2 {...{
      "id": "5--what-can-you-afford"
    }}>{`5 👉 What can you afford?`}</h2>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`At this point you've likely presented your findings to leadership – whoever makes the final call`}</li>
      <li parentName="ol">{`Final tiebreaker is price`}</li>
    </ol>
    <p>{`When it comes to choosing between 2 or 3 vendors who all do what you need, all do it well, and all integrate with your system after writing some glue code 👉 you're in a great position.`}</p>
    <p>{`All you gotta do is pick the cheapest option.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1146484283499880448"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "122.86995515695067%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'492\\'%20viewBox=\\'0%200%20400%20492\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-4%202-7%208-7%2011%200%205%201%209%203%209l1%202c-1%202%207%206%2011%206l8-2c4-3%204-3-2-5l-1-1c0-2%204-5%206-4l1-1c0-1%200-2%201-1l2-1-4-10-3-2c-3-3-11-4-16-1m81%20421l-2%204-2%204c-1%202-1%202%201%203%204%203%2011%202%209-2l1-1%201-2c0-2-1-3-2-3l-2-1c0-1%201-2%202-1v-1c-3-2-4-2-6%200m34-1c-5%204-4%209%200%2012%207%205%2015-6%208-11-3-2-6-3-8-1m-19%201c-1%201%200%202%201%203v2c-4%203-1%208%204%208%206-1%209-9%205-12-1-2-9-2-10-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5d040cf387c2cb3a24850293f0aa5ea/ca0a1/techletter.app-screenshot-1562603963238.webp 223w", "/static/a5d040cf387c2cb3a24850293f0aa5ea/75680/techletter.app-screenshot-1562603963238.webp 445w", "/static/a5d040cf387c2cb3a24850293f0aa5ea/0ba47/techletter.app-screenshot-1562603963238.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5d040cf387c2cb3a24850293f0aa5ea/e92b6/techletter.app-screenshot-1562603963238.png 223w", "/static/a5d040cf387c2cb3a24850293f0aa5ea/e66bf/techletter.app-screenshot-1562603963238.png 445w", "/static/a5d040cf387c2cb3a24850293f0aa5ea/6af66/techletter.app-screenshot-1562603963238.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a5d040cf387c2cb3a24850293f0aa5ea/6af66/techletter.app-screenshot-1562603963238.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Picking the cheapest option can be hard however 😅`}</p>
    <p>{`We were choosing between two vendors. One a very modern SaaS, the other a very sales-focused enterprise.`}</p>
    <p>{`The SaaS was easy.`}</p>
    <p>{`You sign up as a user, try everything out, look at the pricing page, see that it costs $66/month. Simple, self-serve, straight-forward, just what I like to see in a piece of software. Plus Crunchbase says they've got enough funding to stick around awhile. 👌`}</p>
    <p>{`The enterprise was like pulling teeth.`}</p>
    <p>{`We were already a user, just needed some new features. Products as they call them. Unclear what we need to fulfill our needs but looks like the right combination of 2 or 3, maybe 5, products covers everything.`}</p>
    <p>{`There's no sign up button, reach out to them. Support really wants to funnel you into a sales call.`}</p>
    <p>{`Sales person realizes they can't help. You need to talk to that other sales person.`}</p>
    <p>{`Damn can we just try it out? No way sir, we only demo on a sales call so we can do it right. No trying it out yourself.`}</p>
    <p>{`Ok fine.`}</p>
    <p>{`A few video calls later we suss out the tool and ask for pricing. Wait for the offer.`}</p>
    <p>{`$X0,000 with a 1 year commitment.`}</p>
    <p>{`😳`}</p>
    <h2 {...{
      "id": "6--the-real-cost"
    }}>{`6 👉 The real cost??`}</h2>
    <p>{`They gotta be kidding us. $66/month SaaS versus $X0,000 enterprise??`}</p>
    <p><img parentName="p" {...{
        "src": "/ac9535946653f2163bc100ab78df471a/media-EvLq8IpdwfezC-giphy.gif",
        "alt": "ah_but giphy"
      }}></img></p>
    <p>{`Ah but the SaaS requires more glue code. More things to do on our end. More code to maintain. More engineers to keep busy. More things to go wrong.`}</p>
    <p>{`Distributed transactions are a bitch.`}</p>
    <p>{`Ok so you're comparing apples to potatoes here. What does the real cost look like?`}</p>
    <p>{`On one hand you have a $66/month SaaS. That's $792 per year. Plus the cost of integration, maintenance, and dealing with problems.`}</p>
    <p>{`How much are your engineers worth? What else could they be doing instead of writing integrations? 🤔`}</p>
    <p>{`Hard to put a number on those. There's `}<em parentName="p">{`a`}</em>{` number I'm sure, but it's hard to pinpoint. Let's say 2 person days per week averaged out over a year.`}</p>
    <p>{`Some $50,000`}</p>
    <p>{`🤨 hmmmm`}</p>
    <p>{`Suddenly that $X0,000 enterprise quote doesn't look so bad.`}</p>
    <p>{`You give them a call.`}</p>
    <p><em parentName="p">{`"Yo we've got your competitor here at 2 orders of magnitude lower price than your offer. What can you do?"`}</em></p>
    <p>{`They slash the price. You sign the deal.`}</p>
    <p>{`A tough technical decision well made`}</p>
    <p><img parentName="p" {...{
        "src": "/1f443b401c636a8094d81db20ece60e0/media-li9owDEz2DfA4-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      